"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

// Too much files to change
var FeaturedProductAreas = function FeaturedProductAreas(_ref) {
  var fullWidth = _ref.fullWidth,
      allProductAreas = _ref.allProductAreas,
      assignedProductAreas = _ref.assignedProductAreas;
  var productAreaMapping = allProductAreas.reduce(function (acc, productArea) {
    acc[productArea.id] = productArea.name;
    return acc;
  }, {});

  if (fullWidth) {
    return (0, _preact.h)("ul", {
      className: "featured-topic__product-areas"
    }, assignedProductAreas.map(function (assignedProductArea) {
      return (0, _preact.h)("li", {
        key: assignedProductArea,
        className: "featured-topic__product-area"
      }, productAreaMapping[assignedProductArea]);
    }));
  }

  return (0, _preact.h)("ul", {
    className: "featured-topic__product-areas"
  }, (0, _preact.h)("li", {
    className: "featured-topic__product-area"
  }, productAreaMapping[assignedProductAreas[0]]), assignedProductAreas.length > 1 && (0, _preact.h)("li", {
    className: "featured-topic__product-area-count"
  }, "+ ".concat(assignedProductAreas.length - 1)));
};

var _default = FeaturedProductAreas;
exports.default = _default;